import db from 'db';
import { dispatch } from '../store';
import { WATCH_BOARDS, UPDATE_BOARD, REMOVE_BOARD } from './constants';
import { IBoard } from 'types';
import authStore from '../auth';

export function watchBoards() {
  dispatch(WATCH_BOARDS);
  db.board
    .watch()
    .onChildUpdate(doc => dispatch(UPDATE_BOARD, doc.data()))
    .onChildRemove(m => dispatch(REMOVE_BOARD, m.key));
}

export function updateBoard(boardKey: string, update: IBoard): Promise<void> {
  update = { ...update };
  delete update.key;
  update.updated = new Date();
  return db.board.get(boardKey).update(update);
}

export async function createBoard(board: IBoard): Promise<string> {
  board.created = board.updated = new Date();
  board.createBy = authStore.getId();
  const doc = await db.board.addPromise(board);
  return doc.key;
}

export async function cloneBoard(board: IBoard): Promise<string> {
  const clone = { ...board };
  delete clone.key;
  return createBoard(clone);
}
